/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/serving-size-1-lady-bird.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/serving-size-1-lady-bird.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/serving-size-1-lady-bird.mdx';

const metadata = {
  slug: "serving-size-1-lady-bird",
  title: "Serving Size 1: Lady Bird",
  author: "Christian Battaglia",
  description: "A movie review that became a personal reflection. Lady Bird's red hair and Catholic school years trekked me back through my own adolescence — a raw, single serving of emotion that hit different.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/lady-bird.jpeg",
  date: "2017-12-06T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["film","Lady Bird","review","adolescence","Boyhood","music","emotion","Spotify"],
};

export const Route = createFileRoute('/blog/posts/serving-size-1-lady-bird')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/serving-size-1-lady-bird',
    image: '/og/blog/serving-size-1-lady-bird.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
